module.exports = __webpack_public_path__ + "img/14.005e243a.png";